<template>
    <main>
      <canvas id="pesoParaLaEdadNinas5a10A" class="canvas-h canvas-w"></canvas>
    </main>
  </template>
  
  <script>
  import Chart from 'chart.js/auto';
  import chartData from '../../../../../assets/datasheets/charts/pesoParaLaEdadNinas5a10A.json';
  
  export default {
    props : ['x','y'],
    methods : {
      open(){
        const labels = chartData.datapoints;
        const datasets = [];
  
        chartData.series.forEach(s => {
          datasets.push({
            type : 'line',
            label: s.title,
            data: s.data,
            borderColor: s.color,
            fill: false,
            tension: 0.5,
            borderWidth : 1.5,
          });
        });
  
        datasets.push({
          type: 'scatter',
          backgroundColor: 'rgba(75, 00, 150,1)',
          borderColor: 'rgba(75, 00, 150,1)',
          label : 'Peso/Edad',
          data: [{
            "x" : Math.floor(this.x),
            "y" : this.y
          }],
          elements : {
            point : {
              radius : 4
            }
          }
        });
  
        const data = {
          labels: labels,
          datasets: datasets
        };
  
        const config = {
          data: data,
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: 'Peso Para la edad niñas de 5 a 10 Años'
              },
            },
            interaction: {
              intersect: false,
            },
            scales: {
              x: {
                display: true,
                title: {
                  display: true,
                  text: 'Edad En Años'
                },
                ticks: {
                    min: 60, // Iniciar en 5 años (60 meses)
                    max: 120, 
                    callback: function (value) {
                    if(Number(this.getLabelForValue(value)) % 12 === 0){
                        return `${Number(this.getLabelForValue(value))/12} A`;
                    }
                    },
                    stepSize: 1,
                },
              },
                y: {
                    display: true,
                    title: {
                        display: true,
                        text: "Peso (Kg)",
                    },
                    ticks: {
                        stepSize: 5, 
                        min: 10, // Altura mínima
                        max: 60, // Altura máxima
                    },
                },
            },
            elements : {
              point : {
                radius : 0
              }
            }
          },
        };
  
        const ctx = document.getElementById('pesoParaLaEdadNinas5a10A').getContext('2d');
  
        new Chart(ctx, config);
      },
      export(){
        const canva = document.getElementById('pesoParaLaEdadNinas5a10A');
        const urlData = canva.toDataURL('image/png', 0.8);
        return {
          chart : 'Peso para la edad niñas 5 a 10 Años',
          imageData : urlData,
          observaciones:'',
          codigo:'pesoParaLaEdadNinas5a10A'
        };
      }
    },
    created() {
      this.$nextTick(() => this.open());
    }
  }
  
  </script>
  
  <style scoped>
    .canvas-h{
      height: 100%;
    }
    .canvas-w{
      width: 100%;
    }
  </style>